import React from "react";
import { observer } from "mobx-react-lite";
import { Box, Text, useToast } from "@chakra-ui/react";
import { useStores } from "../../../stores/setup/use-store";
import { StoreState } from "../../../enum/StoreState";
import { useTranslation } from "react-i18next";
import { Select } from "antd";
import { useTimezones } from "hooks/useTimezones";

const Timezone: React.FC = () => {
  const {
    dataStores: { userConfigStore, oceanWeatherIntelligenceStore },
  } = useStores();
  const toast = useToast();
  const toastId = "toadId";

  const timezones = useTimezones();

  const { t } = useTranslation("translation", {
    keyPrefix: "settings",
  });

  const handleChangeTimezone = async (value: string) => {
    const success = await userConfigStore.updateUserTimezone(value);
    if (success) {
      userConfigStore.setTimezone(value);
      oceanWeatherIntelligenceStore.setChangeForUpdate({
        update: true,
        expiration: 0,
      });
      if (!toast.isActive(toastId)) {
        toast({
          id: toastId,
          title: t("success"),
          description: t("yourChangesHaveSaved"),
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    }
  };

  return (
    <Box>
      <Text fontSize="lg" mt={5} mb={2}>
        {t("timezone")}
      </Text>
      <Select
        className="custom-blue-border"
        showSearch
        optionFilterProp="children"
        style={{ width: "620px" }}
        dropdownStyle={{ zIndex: 2000 }}
        defaultValue={"America/Sao_Paulo"}
        size="large"
        value={userConfigStore.timezone}
        onChange={(value) => handleChangeTimezone(value)}
        loading={userConfigStore.state === StoreState.PEDDING}
      >
        {timezones.map((x) => (
          <Select.Option value={x.value} key={x.label}>
            {x.label}
          </Select.Option>
        ))}
      </Select>
    </Box>
  );
};

export default observer(Timezone);
